import Bastiat from '../images/Bastiat.jpg';

function BastiatFredericEmbed(){
    return (
        <>
        <img src={Bastiat} alt="Frederic Bastiat Portrait" className="faithImage" />
        </>
    );
};
export default BastiatFredericEmbed;